/* LuzLed product page: item choice, quantity, the add bar and the quote list (key value drawings: luz-keyvalues.js). */
(() => {
  const root = document.querySelector("[data-lp-root]");
  if (!root) return;

  /* Key value drawings (luz-keyvalues.js): colour bar, beam cone, lumen scale; setCct follows the chosen version. */
  const setCct = window.LuzKV ? window.LuzKV.init(root) : () => {};

  /* Floating add bar (phones and tablets): on once the buy row has scrolled up out of view, off while the buy row or
     the footer is on screen, so it never doubles the page's own button or covers the footer. */
  const mbar = root.querySelector(".lp-mbar");
  const buyRow = root.querySelector(".lp-buy");
  if (mbar && buyRow && "IntersectionObserver" in window) {
    let buyGone = false, footIn = false;
    const setBar = () => {
      const on = buyGone && !footIn;
      mbar.classList.toggle("is-on", on);
      document.documentElement.classList.toggle("lp-bar-on", on);
    };
    new IntersectionObserver(([e]) => { buyGone = !e.isIntersecting && e.boundingClientRect.top < 0; setBar(); }).observe(buyRow);
    const foot = document.querySelector(".lf");
    if (foot) new IntersectionObserver(([e]) => { footIn = e.isIntersecting; setBar(); }).observe(foot);
  }

  /* Items of this product and the choice between them. */
  const items = JSON.parse(root.querySelector("[data-lp-items]")?.textContent || "[]");
  const self = JSON.parse(root.querySelector("[data-lp-self]")?.textContent || "{}");
  const stage = root.querySelector("[data-lp-stage]");
  const thumbs = root.querySelector("[data-lp-thumbs]");
  const code = root.querySelector("[data-lp-code]");
  const mainBtns = root.querySelectorAll("[data-lp-add-main]");
  let current = items.find((i) => String(i.id) === root.dataset.product) || items[0];
  setCct(current?.options?.CCT);

  /* Recently viewed, for the search panel (request 79): kept in this browser only, the last six products, and only
     where the visitor allows preferences (the cookie banner in the EEA and the UK; elsewhere Shopify allows them). */
  const remember = () => {
    try {
      if (!window.Shopify?.customerPrivacy?.preferencesProcessingAllowed()) return;
      const rec = { u: location.pathname, n: root.querySelector("h1")?.textContent.trim(), c: current?.code || code?.textContent.trim(),
        i: (current?.media?.[0] || (self.lead_media || [])[0] || {}).thumb || null };
      if (!rec.n) return;
      const list = JSON.parse(localStorage.getItem("luz-recent") || "[]").filter((r) => r.u !== rec.u && r.c !== rec.c);
      localStorage.setItem("luz-recent", JSON.stringify([rec, ...list].slice(0, 6)));
    } catch {}
  };
  /* Shopify's consent API loads with an async script of the platform, ready by the page's load event at the latest. */
  const ask = () => window.Shopify?.loadFeatures?.([{ name: "consent-tracking-api", version: "0.1" }], (err) => { if (!err) remember(); });
  if (window.Shopify?.loadFeatures) ask(); else addEventListener("load", ask, { once: true });
  document.addEventListener("visitorConsentCollected", (e) => { if (e.detail?.preferencesAllowed) remember(); });

  /* The add bar names what it adds: photo, chosen version and code of the current item. */
  const barImg = root.querySelector("[data-lp-mbar-img]");
  const barVer = root.querySelector("[data-lp-mbar-v]");
  const setBarItem = (it) => {
    if (!barVer || !it) return;
    barVer.textContent = [...Object.values(it.options || {}), it.code].filter(Boolean).join(" · ");
    const th = it.media?.[0]?.thumb || self.lead_media?.[0]?.thumb;
    if (th) barImg.src = th;
    const ti = root.querySelector("[data-lp-tabs-img]");
    if (ti && th) { ti.src = th; ti.removeAttribute("srcset"); }
  };
  setBarItem(current);

  const showMedia = (media) => {
    const list = media.length ? media : self.lead_media || [];
    let img = stage.querySelector("img");
    if (!img && list[0]) { stage.querySelector(".lp-noimg")?.remove(); img = document.createElement("img"); stage.prepend(img); img.alt = root.querySelector("h1")?.textContent.trim() || ""; }
    if (img && list[0]) { img.src = list[0].src; img.removeAttribute("srcset"); img.dataset.low = !!list[0].low; }
    const note = root.querySelector("[data-lp-media-note]");
    if (note) note.hidden = media.length > 0;
    thumbs.innerHTML = list.map((m, n) => `<button type="button" class="lp-thumb${n ? "" : " on"}" data-src="${m.src}"${m.low ? " data-low" : ""} aria-label="Photo ${n + 1}"><img src="${m.thumb}" alt="" loading="lazy"></button>`).join("");
    thumbs.hidden = list.length < 2;
  };
  thumbs?.addEventListener("click", (e) => {
    const b = e.target.closest(".lp-thumb");
    if (!b) return;
    thumbs.querySelectorAll(".lp-thumb").forEach((x) => x.classList.toggle("on", x === b));
    const img = stage.querySelector("img");
    img.src = b.dataset.src;
    img.removeAttribute("srcset");
  });

  /* Light colour tile of a product whose versions are light colours: follows the version chosen (request 36). */
  const lcCard = root.querySelector("[data-lp-lc]");
  const LCC = { Red: "#e8352b", Green: "#22b14c", Blue: "#2f6be0", Purple: "#8b3fd9", Yellow: "#f5c400" };
  const setLc = (c) => {
    if (!lcCard || !c) return;
    lcCard.querySelector("[data-lp-lc-v]").textContent = c;
    lcCard.querySelector("[data-lp-lc-dot]").style.setProperty("--c", LCC[c] || "#ffb16e");
  };

  const chosen = () => {
    const o = {};
    root.querySelectorAll("[data-lp-opt]").forEach((g) => {
      const on = g.querySelector(".on");
      if (on) o[g.dataset.lpOpt] = on.dataset.value;
    });
    return o;
  };
  const pick = (o) => items.find((i) => Object.entries(o).every(([k, v]) => i.options[k] === v));
  root.querySelectorAll("[data-lp-opt]").forEach((g) =>
    g.addEventListener("click", (e) => {
      const b = e.target.closest("[data-value]");
      if (!b) return;
      g.querySelectorAll("[data-value]").forEach((x) => x.classList.toggle("on", x === b));
      g.querySelector("[data-lp-opt-shown]").textContent = b.dataset.value;
      const next = pick(chosen()) || items.find((i) => i.options[g.dataset.lpOpt] === b.dataset.value);
      if (!next) return;
      current = next;
      setCct(next.options?.CCT);
      setLc(next.options?.Colour);
      code.textContent = next.code;
      setBarItem(next);
      mainBtns.forEach((m) => (m.dataset.variant = next.variant));
      showMedia(next.media);
      history.replaceState(null, "", next.url);
    }));

  /* Quote list limits: theme settings, passed in window.LuzLimits by layout/theme.liquid. */
  const { qty: MAX_QTY, lines: MAX_LINES } = window.LuzLimits;
  const FULL_LIST = `Your quote list holds up to ${MAX_LINES} products. Send it, then start a new list for the rest.`;
  const FULL_QTY = `Your list already holds ${MAX_QTY.toLocaleString("en")} of this product, the most one list takes. Give the full quantity in your message.`;

  /* Quantity (the add bar adds the quantity set in the page). */
  const qtyInputs = root.querySelectorAll("[data-lp-qty]");
  const setQty = (n) => qtyInputs.forEach((i) => (i.value = Math.max(1, Math.min(MAX_QTY, n | 0))));
  root.querySelectorAll("[data-lp-step]").forEach((b) =>
    b.addEventListener("click", () => setQty(+qtyInputs[0].value + +b.dataset.lpStep)));
  qtyInputs.forEach((i) => i.addEventListener("change", () => setQty(+i.value)));

  root.querySelector("[data-lp-copy]")?.addEventListener("click", (e) => {
    navigator.clipboard?.writeText(code.textContent.trim());
    e.currentTarget.classList.add("done");
    setTimeout(() => e.currentTarget?.classList.remove("done"), 1200);
  });

  /* Quote list: kept in the browser (assets/luz-list.js, request 185), never a price. */
  const drawer = root.querySelector("[data-lp-drawer]");
  const scrim = root.querySelector("[data-lp-scrim]");
  const close = () => { drawer.hidden = true; scrim.hidden = true; };
  root.querySelectorAll("[data-lp-close]").forEach((b) => b.addEventListener("click", close));
  scrim.addEventListener("click", close);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });

  /* info: { name, code, option, img, url } of what is added; the drawer shows it and the rest of the list. */
  const e = (t) => String(t ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  const add = (variant, qty, info) => {
    const r = window.LuzList.add({ v: variant, n: info.name, c: info.code, o: info.option, i: info.img, u: info.url }, qty, "luz-product");
    if (r.blocked) return alertBox(window.LuzList.BLOCKED);
    if (r.full) return alertBox(r.full === "list" ? FULL_LIST : FULL_QTY);
    drawer.querySelector("[data-lp-dr-img]").innerHTML = info.img ? `<img src="${e(info.img)}" alt="">` : "";
    drawer.querySelector("[data-lp-dr-name]").textContent = info.name;
    drawer.querySelector("[data-lp-dr-code]").textContent = [info.code, info.option].filter(Boolean).join(" · ");
    const dq = drawer.querySelector("[data-lp-dr-qty]");
    dq.textContent = r.q === r.added ? `Quantity ${r.added}` : `Added ${r.added} · ${r.q} in your list`;
    if (r.q >= MAX_QTY) dq.textContent += ", the most one list takes";
    drawer.querySelector("[data-lp-dr-count]").textContent = `${r.count} ${r.count === 1 ? "product" : "products"} in your list`;
    /* The other products in the list. */
    const others = window.LuzList.lines().filter((l) => +l.v !== +variant);
    const noimg = '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 6v6M9.5 12.5l4 4M38.5 12.5l-4 4M16 30a8 8 0 1 1 16 0c0 3-2 4.5-3 6.5h-10c-1-2-3-3.5-3-6.5ZM19 41h10"/></svg>';
    drawer.querySelector("[data-lp-dr-list]").innerHTML = others.map((l) =>
      `<div class="lp-dr-row"><span class="i">${l.i ? `<img src="${e(l.i)}" alt="">` : noimg}</span><div><b>${e(l.n)}</b>` +
      `<small>${e(l.c)}${l.o ? ` · ${e(l.o)}` : ""}</small></div><span class="q">${e(l.q)}</span></div>`).join("");
    drawer.querySelector("[data-lp-dr-more]").hidden = !others.length;
    scrim.hidden = false;
    drawer.hidden = false;
    drawer.querySelector("[data-lp-close]").focus();
  };
  /* The + of the page's cards (luz-quick-add.js, request 169) adds through this drawer too. */
  window.LuzProduct = { add };
  const alertBox = (msg) => {
    const n = document.createElement("div");
    n.className = "lp-toast";
    n.textContent = msg;
    n.setAttribute("role", "status");
    n.style.cssText = "position:fixed;left:50%;bottom:96px;transform:translateX(-50%);width:max-content;max-width:min(440px,calc(100vw - 32px));background:#111413;color:#fff;padding:12px 18px;border-radius:18px;font-size:14px;line-height:1.4;text-align:center;z-index:50";
    document.body.appendChild(n);
    setTimeout(() => n.remove(), Math.max(3000, msg.length * 60));
  };

  mainBtns.forEach((b) =>
    b.addEventListener("click", () => {
      const img = (current.media[0] || (self.lead_media || [])[0] || {}).thumb;
      /* The version as the cards and the search name it: the option values, only where the product has versions. */
      const option = items.length > 1 ? Object.values(current.options || {}).join(" ") : "";
      add(b.dataset.variant, +qtyInputs[0].value || 1, { name: self.name, code: current.code, option, img, url: current.url });
    }));

  /* The section bar takes the main menu's place: the menu slides away when the bar meets it and comes back when the
     bar's place scrolls below it again; stuck, the bar shows the product and the add button (request 126). */
  const tabsBar = root.querySelector("[data-lp-tabs]");
  const tabsMark = root.querySelector(".lp-tabs-mark");
  if (tabsBar && tabsMark) {
    let tick = false;
    const place = () => {
      tick = false;
      const y = tabsMark.getBoundingClientRect().top;
      const head = document.querySelector(".lhd-wrap")?.offsetHeight || 0;
      document.documentElement.classList.toggle("lhd-away", y <= head);
      tabsBar.classList.toggle("is-stuck", y <= parseFloat(getComputedStyle(tabsBar).top) + 1);
    };
    addEventListener("scroll", () => { if (!tick) { tick = true; requestAnimationFrame(place); } }, { passive: true });
    addEventListener("resize", place);
    place();
  }

  /* The section bar follows the scroll. */
  const links = [...root.querySelectorAll(".lp-tabs a")];
  /* On phones the tabs scroll sideways: the edge that hides more fades, and the current tab is brought into view. */
  const strip = root.querySelector(".lp-tabs-links");
  const edge = () => {
    if (!strip) return;
    const more = strip.scrollWidth - strip.clientWidth > 2;
    strip.classList.toggle("fade-l", more && strip.scrollLeft > 2);
    strip.classList.toggle("fade-r", more && strip.scrollLeft + strip.clientWidth < strip.scrollWidth - 2);
  };
  strip?.addEventListener("scroll", edge, { passive: true });
  addEventListener("resize", edge);
  edge();
  const io = new IntersectionObserver((es) => es.forEach((en) => {
    if (!en.isIntersecting) return;
    links.forEach((a) => a.classList.toggle("on", a.getAttribute("href") === "#" + en.target.id));
    const on = strip?.querySelector("a.on");
    if (on && strip.scrollWidth > strip.clientWidth) {
      const x = on.offsetLeft - strip.offsetLeft;
      if (x < strip.scrollLeft || x + on.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: x - 16, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    }
  }), { rootMargin: "-40% 0px -55% 0px" });
  links.forEach((a) => { const s = root.querySelector(a.getAttribute("href")); if (s) io.observe(s); });

  /* Back: to the list the visitor came from (filters and search kept), else to the category. */
  const back = root.querySelector("[data-lp-back]");
  try {
    const ref = document.referrer && new URL(document.referrer);
    if (back && ref && ref.origin === location.origin && /^\/(collections|search)/.test(ref.pathname)) {
      back.href = ref.pathname + ref.search;
      back.querySelector("[data-lp-back-t]").textContent = "Back to results";
      // going back through history keeps the list, its filters and where it was scrolled
      if (history.length > 1) back.addEventListener("click", (e) => { e.preventDefault(); history.back(); });
    }
  } catch {}
})();
